import {FC, useMemo} from 'react'
import {ID} from '../../_metronic/helpers'

type Props = {
  id: ID
  selected: ID[]
  onSelect: (id: ID) => void
}

export const SelectionCell: FC<Props> = (props) => {
  const isSelected = useMemo(() => props.selected.includes(props.id), [props.id, props.selected])

  return (
    <div className='flex items-center'>
      <input
        type='checkbox'
        className='w-4 h-4 text-primary border-gray-300 rounded focus:ring-2 focus:ring-offset-1 focus:ring-primary'
        data-kt-check={isSelected}
        data-kt-check-target='#kt_table_academic_years .form-check-input'
        checked={isSelected}
        onChange={() => props.onSelect(props.id)}
      />
    </div>
  )
}
